import { Anchor, Breadcrumbs, Card, Grid, Text } from '@mantine/core';
import queryString from 'query-string';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import ErrorMessage from '../../components/ErrorMessage';
import Metadata from '../../components/Metadata';
import GuidanceModal from '../../components/UserFlows/guidanceModal';
import WebhookForm from '../../components/Webhooks/WebhookForm';
import { Page } from '../../constants/pageTitles';
import useFetch from '../../helpers/useFetch';

const page = `${Page['webhook']}`;

const WebhooksNewPage = () => {
  const fetch = useFetch();
  const location = useLocation();
  const navigate = useNavigate();

  const [webhook, setWebhook] = useState();
  const [userError, setUserError] = useState();
  const [loadError, setLoadError] = useState();
  const [guidanceShow, setGuidanceShow] = useState(false);

  const { accountId, domainId } = useParams();

  useEffect(() => {
    const from = queryString.parse(location.search).from;
    if (from) {
      fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/webhooks/${from}`)
        .then(({ webhook }) => {
          webhook.name = `Copy of ${webhook.name}`;
          delete webhook.id;
          setWebhook(webhook);
        })
        .catch(setLoadError);
    } else {
      setWebhook({
        name: `New Webhook ${new Date().getTime()}`,
        url: '',
        queryMapping: [],
        bodyMapping: [],
        headers: [],
        method: 'post',
        type: 'standard',
        contentType: 'application/json',
        productFeedId: null,
        secretId: null,
        onDailyLimitReached: 'reschedule',
        maxReschedules: 3,
      });
    }
  }, [accountId, domainId, fetch, location.search]);

  const create = (webhook) => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/webhooks`, {
      method: 'POST',
      body: JSON.stringify(webhook),
    })
      .then((response) => {
        setWebhook(response.webhook);
        setGuidanceShow(true);
      })
      .catch(setUserError);
  };

  if (loadError) {
    return <ErrorMessage message={loadError.message} />;
  }

  const breadcrumbItems = [
    { title: 'Home', href: `#/accounts/${accountId}/domains/${domainId}/analytics` },
    { title: page, href: `#/accounts/${accountId}/domains/${domainId}/webhooks` },
    { title: 'New' },
  ].map((item, index) =>
    item.href ? (
      <Anchor href={item.href} key={index}>
        {item.title}
      </Anchor>
    ) : (
      <Text key={index}>{item.title}</Text>
    )
  );

  return (
    <>
      <Metadata title={`${page} | New`} />
      <Breadcrumbs mb="md">{breadcrumbItems}</Breadcrumbs>
      <GuidanceModal
        type="Webhook"
        redirect={`/accounts/${accountId}/domains/${domainId}/webhooks`}
        show={guidanceShow}
        elementTypes={['workflows']}
        element={webhook}
        setShow={() => setGuidanceShow(false)}
        newElement={true}
      />
      <Grid>
        <Grid.Col span={12}>
          <Card withBorder>
            <WebhookForm webhook={webhook} saveWebhook={(webhook) => create(webhook)} onBack={() => navigate(-1)} />
          </Card>
        </Grid.Col>
      </Grid>
      {userError ? (
        <div style={{ textAlign: 'right' }}>
          <ErrorMessage message={userError.message} />
        </div>
      ) : null}
    </>
  );
};

export default WebhooksNewPage;
